var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 12.4507C15.0259 14.2324 13.5861 15.6721 11.8044 15.6721C10.0227 15.6721 8.58301 14.2324 8.58301 12.4507C8.58301 10.669 10.0227 9.22925 11.8044 9.22925C13.5861 9.22925 15.0259 10.669 15.0259 12.4507Z",
    stroke: "#8F0A0C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.805 19.8925C14.9815 19.8925 17.942 18.0208 20.0026 14.7813C20.8125 13.5126 20.8125 11.3799 20.0026 10.1111C17.942 6.87168 14.9815 5 11.805 5C8.62853 5 5.66804 6.87168 3.6074 10.1111C2.79753 11.3799 2.79753 13.5126 3.6074 14.7813C5.66804 18.0208 8.62853 19.8925 11.805 19.8925Z",
    stroke: "#8F0A0C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlActiveIcon);
export default __webpack_public_path__ + "static/media/control-active-icon.82356b3d32c2ab01dad356a4fc28ae8e.svg";
export { ForwardRef as ReactComponent };